module.exports = __webpack_public_path__ + "static/mongodb-query-optimization-01-1505c1e4a4b2675d672b11e47ce0fbfa.png";